import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, LobbyBannerContext, UserContext } from 'commons-ui';

import { APP_LANGUAGE } from 'commons/models/common';
import { IUpdateKeyResponse } from 'pages/admin/zooKeeper/utils/zk.interface';
import { dehydrateFormData, hydrateEditFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { ITournamentBanner, TTournamentBannerConfig } from '../../utils/constants';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const history = useHistory();
	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	const { requestCreateLobbyBanner, handleCreateConfigBasedLobbyBanner } = useService();
	const { lobbyBannerData: lobbyBannerRows } = useContext(LobbyBannerContext);

	const cloneLobbyBanner = (clonedData: ITournamentBanner, language: APP_LANGUAGE) => {
		setShowLoader(true);

		const lobbyBannerDataConfig: TTournamentBannerConfig = handleCreateConfigBasedLobbyBanner(
			clonedData,
			lobbyBannerRows.data,
			language
		);

		requestCreateLobbyBanner(app.appName, user, lobbyBannerRows.gameName, lobbyBannerDataConfig).then(
			(res: IUpdateKeyResponse) => {
				if (!res?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the banner', { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Banner created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		const { language } = submittedData;
		cloneLobbyBanner(dehydrateFormData(submittedData), language);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateEditFormData(data),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
